
import { alpha, Box, Tooltip, Typography, useTheme } from '@mui/material'
import { GridColDef, GridFooterContainer, GridRowCount } from '@mui/x-data-grid-pro'
import React from 'react'
import { formatCurrency } from '../DealsKanban/aggregateStageTotals'
import { EXCLUDED_KEYS } from './EXCLUDED_KEYS'
import { renderServiceIcon } from './renderServiceIcon'

interface TotalsFooterProps {
  grossTotals: { [key: string]: number }
  dynamicColumns: GridColDef[]
  rowCount: number
}

const TotalsFooter: React.FC<TotalsFooterProps> = ({ grossTotals, dynamicColumns, rowCount }) => {
  const theme = useTheme()
  // Filter dynamic columns to only those with a nonzero gross total.
  const columnsWithTotals = dynamicColumns.filter(col => !EXCLUDED_KEYS.has(col.field) && (grossTotals[col.field] || 0))

  return (
    <GridFooterContainer>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          width: '100%',
          backgroundColor: alpha(theme.palette.text.primary, 0.04),
        }}
      >
        <GridRowCount rowCount={rowCount} visibleRowCount={rowCount} />
        {columnsWithTotals.map(col => (
          <Box key={col.field} sx={{ ml: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
            <Tooltip title={col.headerName}>
              <img src={renderServiceIcon(col.headerName)} style={{ height: 24, width: 24 }} />
            </Tooltip>
            <Typography variant="body2" fontWeight="bold">
              {formatCurrency(grossTotals[col.field] || 0)}
            </Typography>
          </Box>
        ))}
      </Box>
    </GridFooterContainer>
  )
}

export default TotalsFooter
